import { formatDistanceToNowStrict, intervalToDuration, differenceInDays } from 'date-fns';

export const getDateDistanceToNow = (date?: string | number | null): string | null => {
  // converting epoch string to number
  if (typeof date === 'string' && !isNaN(Number(date))) {
    date = parseInt(date);
  }
  return date ? formatDistanceToNowStrict(new Date(date), { addSuffix: true }) : null;
};

export const getDateAndHourDifferenceToNow = (endDate?: Date | number | string, dateType?: string) => {
  let result = '';
  let hasExpired = false;
  let isLessThanFiveDays = false;
  const today = new Date();
  const formattedEndDate = endDate && new Date(endDate);
  const { months, days, hours, minutes, seconds } = intervalToDuration({
    start: today,
    end: formattedEndDate as Date,
  });

  if (months && months > 0) {
    const days = differenceInDays(today, formattedEndDate as Date);
    result += `${days}d`;
  } else {
    if (days && days > 0) result += `${days}d`;
    isLessThanFiveDays = (days && days < 5) || result === '' || !!(days && days === 5 && !hours);
  }

  if (hours && hours > 0) result += result ? ' ' + `${hours}h` : `${hours}h`;
  if (result === '' && minutes && minutes > 0) {
    result += `${minutes}m`;
  }
  if (result === '' && seconds) {
    result += `${seconds}s`;
  }

  if (formattedEndDate && today > formattedEndDate && dateType === 'expiry-date') {
    result += ' ' + 'ago';
    hasExpired = true;
    isLessThanFiveDays = false;
  }

  return { result, isLessThanFiveDays, hasExpired };
};
